import { useMemo } from 'react';
import { MessageRole } from '../../../../../ai';
export var useMessageContent = function useMessageContent(_ref) {
  var message = _ref.message,
      contentOverride = _ref.contentOverride,
      isStreamingProp = _ref.isStreaming;
  var isUser = message.role === MessageRole.User;
  var displayContent = useMemo(function () {
    var _message$content$valu, _message$content;

    return contentOverride !== undefined && contentOverride !== null ? contentOverride : (_message$content$valu = message === null || message === void 0 ? void 0 : (_message$content = message.content) === null || _message$content === void 0 ? void 0 : _message$content.value) !== null && _message$content$valu !== void 0 ? _message$content$valu : '';
  }, [message.content, contentOverride]);
  var isStreaming = isStreamingProp !== null && isStreamingProp !== void 0 ? isStreamingProp : message.content.value.startsWith('{');
  return {
    isUser: isUser,
    isStreaming: isStreaming,
    displayContent: displayContent
  };
};